import React from "react";
import StackTokenv2Section from "../sections/StackTokenv2Section/Content";
const StackTokenv2Page = () => {
  return <StackTokenv2Section />;
};

export default StackTokenv2Page;
